module.exports = __webpack_public_path__ + "static/media/play-circle.34a3149c.svg";